<main class="!mx-auto !w-full !max-w-3xl !pb-28 !text-strong sm:!pb-12">
    <a [routerLink]="['/users/dashboard']"
       class="!mb-5 !inline-flex !min-h-[40px] !items-center !gap-2 !text-sm !font-medium !text-slate-600 hover:!text-primary">
        <i class="bi bi-arrow-left" aria-hidden="true"></i> Torna all'area riservata
    </a>

    <header class="!mb-6">
        <h1 class="!m-0 !text-2xl !font-bold !tracking-tight !text-strong sm:!text-3xl">Iscrivi nuovo atleta</h1>
        <p class="!mb-0 !mt-2 !text-sm !leading-6 !text-slate-600">
            Bastano pochi minuti. Dopo l'invio la società sportiva verificherà la richiesta.
        </p>
    </header>

    <!-- Stepper: compatto su telefono, con etichette da sm in su -->
    <nav class="!mb-6" aria-label="Passaggi dell'iscrizione">
        <div class="!mb-2 !flex !items-center !justify-between !text-sm sm:!hidden">
            <span class="!font-semibold !text-strong">{{ steps[currentStep].title }}</span>
            <span class="!text-slate-600">Passo {{ currentStep + 1 }} di {{ steps.length }}</span>
        </div>
        <div class="!h-1.5 !overflow-hidden !rounded-full !bg-slate-200 sm:!hidden" aria-hidden="true">
            <div class="!h-full !rounded-full !bg-primary !transition-all !duration-300" [style.width.%]="progressPercent"></div>
        </div>

        <ol class="!m-0 !hidden !list-none !gap-2 !p-0 sm:!grid sm:!grid-cols-4">
            <li *ngFor="let step of steps; let i = index">
                <button type="button"
                        class="!flex !w-full !flex-col !gap-2 !border-0 !bg-transparent !p-0 !text-left disabled:!cursor-not-allowed focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-4 focus-visible:!outline-primary"
                        [disabled]="!canJumpTo(i)"
                        [attr.aria-current]="i === currentStep ? 'step' : null"
                        (click)="goToStep(i)">
                    <span class="!h-1.5 !w-full !rounded-full !transition-colors"
                          [ngClass]="i <= currentStep ? '!bg-primary' : '!bg-slate-200'"></span>
                    <span class="!flex !items-center !gap-2 !text-sm"
                          [ngClass]="i === currentStep ? '!font-semibold !text-strong' : (i < currentStep ? '!text-slate-700' : '!text-slate-400')">
                        <span class="!grid !h-6 !w-6 !shrink-0 !place-items-center !rounded-full !text-xs !font-bold"
                              [ngClass]="i < currentStep ? '!bg-primary !text-white' : (i === currentStep ? '!bg-primary-soft !text-primary' : '!bg-slate-100 !text-slate-500')">
                            <i *ngIf="i < currentStep" class="bi bi-check-lg" aria-hidden="true"></i>
                            <ng-container *ngIf="i >= currentStep">{{ i + 1 }}</ng-container>
                        </span>
                        <span class="!leading-tight">{{ step.title }}</span>
                    </span>
                </button>
            </li>
        </ol>
    </nav>

    <form class="!rounded-2xl !border !border-solid !border-slate-200 !bg-white !p-5 sm:!p-8" novalidate
          (ngSubmit)="isLastStep ? submit() : next()">
        <div class="!mb-6 !border-0 !border-b !border-solid !border-slate-100 !pb-4">
            <h2 #stepHeading tabindex="-1" class="!m-0 !text-lg !font-bold !text-strong focus:!outline-none sm:!text-xl">
                {{ steps[currentStep].title }}
            </h2>
            <p class="!mb-0 !mt-1 !text-sm !leading-6 !text-slate-600">{{ steps[currentStep].description }}</p>
        </div>

        <!-- Passo 1: anagrafica -->
        <div *ngIf="currentStep === 0" class="!grid !grid-cols-1 !gap-5 md:!grid-cols-2">
            <div class="!min-w-0">
                <label for="athlete-first-name" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Nome</label>
                <input id="athlete-first-name" data-field="firstName" type="text" name="firstName"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       autocomplete="off" autocapitalize="words" spellcheck="false" maxlength="60"
                       [(ngModel)]="athlete.firstName"
                       [class.is-invalid]="showError('firstName')"
                       [attr.aria-invalid]="!!showError('firstName')"
                       aria-describedby="athlete-first-name-error"
                       (blur)="normalizeText('firstName'); markTouched('firstName')">
                <p id="athlete-first-name-error" class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('firstName') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0">
                <label for="athlete-last-name" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Cognome</label>
                <input id="athlete-last-name" data-field="lastName" type="text" name="lastName"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       autocomplete="off" autocapitalize="words" spellcheck="false" maxlength="60"
                       [(ngModel)]="athlete.lastName"
                       [class.is-invalid]="showError('lastName')"
                       [attr.aria-invalid]="!!showError('lastName')"
                       aria-describedby="athlete-last-name-error"
                       (blur)="normalizeText('lastName'); markTouched('lastName')">
                <p id="athlete-last-name-error" class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('lastName') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0">
                <label for="athlete-born-date" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Data di nascita</label>
                <input id="athlete-born-date" data-field="bornDate" type="date" name="bornDate"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [min]="minBornDate" [max]="today"
                       [(ngModel)]="athlete.bornDate"
                       [class.is-invalid]="showError('bornDate')"
                       [attr.aria-invalid]="!!showError('bornDate')"
                       aria-describedby="athlete-born-date-error"
                       (blur)="markTouched('bornDate')">
                <p id="athlete-born-date-error" class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('bornDate') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0">
                <label for="athlete-born-city" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Luogo di nascita</label>
                <input id="athlete-born-city" data-field="bornCity" type="text" name="bornCity"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       placeholder="Es. Milano" autocomplete="off" autocapitalize="words" maxlength="80"
                       [(ngModel)]="athlete.bornCity"
                       [class.is-invalid]="showError('bornCity')"
                       [attr.aria-invalid]="!!showError('bornCity')"
                       aria-describedby="athlete-born-city-error"
                       (blur)="normalizeText('bornCity'); markTouched('bornCity')">
                <p id="athlete-born-city-error" class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('bornCity') as error">{{ error }}</p>
            </div>

            <fieldset class="!m-0 !min-w-0 !border-0 !p-0 md:!col-span-2" aria-describedby="athlete-citizenship-error">
                <legend class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Nazionalità</legend>
                <div class="!grid !grid-cols-1 !gap-2 sm:!grid-cols-3">
                    <label *ngFor="let type of citizenshipTypes; let first = first"
                           class="!m-0 !flex !min-h-11 !cursor-pointer !items-center !gap-3 !rounded-xl !border !border-solid !px-4 !py-2.5 !text-sm !font-medium !transition focus-within:!ring-2 focus-within:!ring-primary"
                           [ngClass]="athlete.citizenshipType === type.id ? '!border-primary !bg-primary-soft !text-strong' : (showError('citizenshipType') ? '!border-red-400 !text-slate-700' : '!border-slate-200 !text-slate-700 hover:!border-slate-300')">
                        <input type="radio" name="citizenshipType" class="form-check-input !m-0 !shrink-0"
                               [attr.data-field]="first ? 'citizenshipType' : null"
                               [value]="type.id" [(ngModel)]="athlete.citizenshipType"
                               (change)="markTouched('citizenshipType')">
                        {{ type.name }}
                    </label>
                </div>
                <p id="athlete-citizenship-error" class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('citizenshipType') as error">{{ error }}</p>
            </fieldset>

            <div class="!min-w-0 md:!col-span-2">
                <label for="athlete-fiscal-code" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Codice fiscale</label>
                <input id="athlete-fiscal-code" data-field="fiscalCode" type="text" name="fiscalCode"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !font-mono !text-base !uppercase !tracking-wider focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="16"
                       placeholder="RSSMRA10A01F205X"
                       [ngModel]="athlete.fiscalCode" (ngModelChange)="onFiscalCodeInput($event)"
                       [class.is-invalid]="showError('fiscalCode')"
                       [attr.aria-invalid]="!!showError('fiscalCode')"
                       aria-describedby="athlete-fiscal-code-help"
                       (blur)="markTouched('fiscalCode')">
                <div id="athlete-fiscal-code-help" class="!mt-1.5 !flex !items-start !justify-between !gap-3">
                    <span class="!text-sm !text-red-600" *ngIf="showError('fiscalCode') as error; else fiscalCodeHint">{{ error }}</span>
                    <ng-template #fiscalCodeHint>
                        <span class="!text-xs !leading-snug !text-slate-500">16 caratteri, lo trovi sulla tessera sanitaria.</span>
                    </ng-template>
                    <span class="!shrink-0 !text-xs !font-semibold !tabular-nums"
                          [ngClass]="fiscalCodeLength === 16 && !errorFor('fiscalCode') ? '!text-primary' : '!text-slate-400'">
                        {{ fiscalCodeLength }}/16
                    </span>
                </div>
                <p *ngIf="fiscalCodeBirthDateMismatch"
                   class="!mb-0 !mt-2 !flex !items-start !gap-2 !rounded-lg !bg-amber-50 !px-3 !py-2 !text-sm !leading-5 !text-amber-800">
                    <i class="bi bi-exclamation-triangle !mt-0.5 !shrink-0" aria-hidden="true"></i>
                    La data di nascita nel codice fiscale non coincide con quella inserita sopra. Controlla che siano corrette.
                </p>
            </div>
        </div>

        <!-- Passo 2: residenza e contatti -->
        <div *ngIf="currentStep === 1" class="!grid !grid-cols-1 !gap-5 md:!grid-cols-2">
            <div class="!min-w-0 md:!col-span-2" data-field="address" (focusout)="markTouched('address')">
                <ui-address-search
                    inputId="athlete-address"
                    name="address"
                    label="Indirizzo di residenza"
                    placeholder="Es. Via Roma 10, Milano"
                    [hint]="showError('address') ? '' : 'Inizia a scrivere e scegli un suggerimento: città e provincia si compilano da sole.'"
                    [required]="true"
                    [value]="athlete.address || ''"
                    (valueChange)="athlete.address = $event"
                    (selected)="onAddressSelected($event)">
                </ui-address-search>
                <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('address') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0">
                <label for="athlete-city" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Città</label>
                <input id="athlete-city" data-field="city" type="text" name="city"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       autocomplete="off" autocapitalize="words" maxlength="80"
                       [(ngModel)]="athlete.city"
                       [class.is-invalid]="showError('city')"
                       [attr.aria-invalid]="!!showError('city')"
                       (blur)="normalizeText('city'); markTouched('city')">
                <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('city') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0">
                <label for="athlete-province" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Provincia</label>
                <select id="athlete-province" data-field="province" name="province"
                        class="form-select !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary"
                        [(ngModel)]="athlete.province"
                        [class.is-invalid]="showError('province')"
                        [attr.aria-invalid]="!!showError('province')"
                        (blur)="markTouched('province')">
                    <option [ngValue]="undefined" disabled>Seleziona la provincia</option>
                    <option *ngFor="let province of provinces" [ngValue]="province.id">{{ province.name }}</option>
                </select>
                <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('province') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0">
                <label for="athlete-email" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Email</label>
                <input id="athlete-email" data-field="email" type="email" name="email" inputmode="email"
                       class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       autocomplete="email" autocapitalize="none" spellcheck="false" placeholder="nome@esempio.it"
                       [(ngModel)]="athlete.email"
                       [class.is-invalid]="showError('email')"
                       [attr.aria-invalid]="!!showError('email')"
                       aria-describedby="athlete-email-error"
                       (blur)="normalizeText('email'); markTouched('email')">
                <p id="athlete-email-error" class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('email') as error">{{ error }}</p>
            </div>

            <div class="!min-w-0" data-field="phone" tabindex="-1">
                <ui-phone-field
                    inputId="athlete-phone"
                    name="phone"
                    label="Telefono"
                    [required]="true"
                    [showHint]="!showError('phone')"
                    [value]="athlete.phone || ''"
                    (valueChange)="onPhoneChange($event)">
                </ui-phone-field>
                <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('phone') as error">{{ error }}</p>
            </div>
        </div>

        <!-- Passo 3: esperienza sportiva -->
        <div *ngIf="currentStep === 2" class="!flex !flex-col !gap-6">
            <fieldset class="!m-0 !border-0 !p-0">
                <legend class="form-label required !mb-2 !text-sm !font-semibold !text-slate-700">L'atleta ha già giocato in questa società?</legend>
                <div class="!grid !grid-cols-2 !gap-2">
                    <label *ngFor="let option of [{value: 1, label: 'Sì'}, {value: 0, label: 'No'}]; let first = first"
                           class="!m-0 !flex !min-h-11 !cursor-pointer !items-center !justify-center !gap-2 !rounded-xl !border !border-solid !px-4 !py-2.5 !text-sm !font-semibold !transition focus-within:!ring-2 focus-within:!ring-primary"
                           [ngClass]="athlete.alreadyPlayedInCompany === option.value ? '!border-primary !bg-primary-soft !text-strong' : (showError('alreadyPlayedInCompany') ? '!border-red-400 !text-slate-700' : '!border-slate-200 !text-slate-700 hover:!border-slate-300')">
                        <input type="radio" name="alreadyPlayedInCompany" class="form-check-input !m-0"
                               [attr.data-field]="first ? 'alreadyPlayedInCompany' : null"
                               [checked]="athlete.alreadyPlayedInCompany === option.value"
                               (change)="setAlreadyPlayed(option.value)">
                        {{ option.label }}
                    </label>
                </div>
                <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('alreadyPlayedInCompany') as error">{{ error }}</p>

                <div *ngIf="athlete.alreadyPlayedInCompany === 0" class="!mt-4">
                    <label for="athlete-previous-company" class="form-label !mb-1.5 !text-sm !font-semibold !text-slate-600">
                        Ultima società sportiva <span class="!font-normal !text-slate-400">(facoltativo)</span>
                    </label>
                    <input id="athlete-previous-company" type="text" name="previousCompanyName"
                           class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                           placeholder="Es. ASD Sport Club" autocomplete="off" maxlength="120"
                           [(ngModel)]="athlete.previousCompanyName"
                           (blur)="normalizeText('previousCompanyName')">
                </div>
            </fieldset>

            <fieldset class="!m-0 !border-0 !p-0">
                <legend class="form-label required !mb-2 !text-sm !font-semibold !text-slate-700">È la prima volta che pratica uno sport agonistico?</legend>
                <div class="!grid !grid-cols-2 !gap-2">
                    <label *ngFor="let option of [{value: '1', label: 'Sì'}, {value: '0', label: 'No'}]; let first = first"
                           class="!m-0 !flex !min-h-11 !cursor-pointer !items-center !justify-center !gap-2 !rounded-xl !border !border-solid !px-4 !py-2.5 !text-sm !font-semibold !transition focus-within:!ring-2 focus-within:!ring-primary"
                           [ngClass]="athlete.firstTimeAgonistic === option.value ? '!border-primary !bg-primary-soft !text-strong' : (showError('firstTimeAgonistic') ? '!border-red-400 !text-slate-700' : '!border-slate-200 !text-slate-700 hover:!border-slate-300')">
                        <input type="radio" name="firstTimeAgonistic" class="form-check-input !m-0"
                               [attr.data-field]="first ? 'firstTimeAgonistic' : null"
                               [value]="option.value" [(ngModel)]="athlete.firstTimeAgonistic"
                               (change)="markTouched('firstTimeAgonistic')">
                        {{ option.label }}
                    </label>
                </div>
                <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('firstTimeAgonistic') as error">{{ error }}</p>
            </fieldset>
        </div>

        <!-- Passo 4: riepilogo -->
        <div *ngIf="currentStep === 3" class="!flex !flex-col !gap-4">
            <section *ngFor="let group of summaryGroups"
                     class="!rounded-xl !border !border-solid !border-slate-200">
                <div class="!flex !items-center !justify-between !gap-3 !border-0 !border-b !border-solid !border-slate-100 !px-4 !py-3">
                    <h3 class="!m-0 !text-sm !font-bold !text-strong">{{ steps[group.step].title }}</h3>
                    <button type="button"
                            class="!inline-flex !min-h-[36px] !items-center !gap-1.5 !rounded-lg !border-0 !bg-transparent !px-2 !text-sm !font-semibold !text-primary hover:!bg-primary-soft"
                            (click)="goToStep(group.step)">
                        <i class="bi bi-pencil" aria-hidden="true"></i> Modifica
                    </button>
                </div>
                <dl class="!m-0 !divide-y !divide-slate-100 !px-4">
                    <div *ngFor="let row of group.rows" class="!flex !flex-col !gap-0.5 !py-2.5 sm:!flex-row sm:!justify-between sm:!gap-4">
                        <dt class="!text-sm !font-normal !text-slate-500">{{ row.label }}</dt>
                        <dd class="!m-0 !break-words !text-sm !font-semibold !text-strong sm:!text-right">{{ row.value }}</dd>
                    </div>
                </dl>
            </section>
            <p *ngIf="fiscalCodeBirthDateMismatch"
               class="!m-0 !flex !items-start !gap-2 !rounded-lg !bg-amber-50 !px-3 !py-2 !text-sm !leading-5 !text-amber-800">
                <i class="bi bi-exclamation-triangle !mt-0.5 !shrink-0" aria-hidden="true"></i>
                La data di nascita nel codice fiscale non coincide con quella inserita: verifica prima di inviare.
            </p>
        </div>

        <!-- Azioni: barra fissa in basso su telefono -->
        <div class="!fixed !inset-x-0 !bottom-0 !z-[1000] !flex !gap-3 !border-0 !border-t !border-solid !border-slate-200 !bg-white/95 !px-4 !py-3 !backdrop-blur sm:!static sm:!mt-8 sm:!justify-between sm:!border-slate-100 sm:!bg-transparent sm:!px-0 sm:!pb-0 sm:!pt-6">
            <button type="button" class="btn welldone-btn-gray !inline-flex !min-h-[44px] !flex-1 !items-center !justify-center !gap-2 sm:!flex-none"
                    [disabled]="submitting" (click)="back()">
                <i class="bi bi-arrow-left" aria-hidden="true"></i>
                {{ currentStep === 0 ? 'Annulla' : 'Indietro' }}
            </button>
            <button type="submit" class="btn btn-primary !inline-flex !min-h-[44px] !flex-[2] !items-center !justify-center !gap-2 sm:!flex-none"
                    [disabled]="submitting || checkingFiscalCode">
                <span *ngIf="checkingFiscalCode || submitting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <ng-container *ngIf="!isLastStep">Continua <i class="bi bi-arrow-right" aria-hidden="true"></i></ng-container>
                <ng-container *ngIf="isLastStep">Invia iscrizione <i class="bi bi-check-lg" aria-hidden="true"></i></ng-container>
            </button>
        </div>
    </form>
</main>
